export default {
  customer_btn_add: 'Add New Customer',

  // customer
  customer_title: 'Customer',
  customer_form_all_customer: 'All Customer',
  customer_form_select_placehoder: 'Select a customer',
  customer_title_list: 'Site List',
  customer_title_user: 'User List',
  customer_title_items: 'items',

  // confirm
  customer_confirm_delete_title: 'Do you confirm to delete this Customer?',
  customer_confirm_delete_content: 'Customer Name: {name}',

  customer_form_order_1: 'Customer Name',
  customer_form_order_2: 'Create Time',
  customer_form_order_3: 'Update Time',

  // table
  customer_table_site_created: 'Site Created',
  customer_table_user: 'User Number',
  customer_table_platform: 'Platform Customer',
  customer_table_read: 'Only Read',

  // form
  customer_form_name: 'Customer Name',
  customer_form_name_placeholder: 'Please input customer name',
  customer_form_code: 'Customer Code',
  customer_form_code_placeholder: 'Please input customer code',
  customer_form_logo: 'Customer Logo',
};
